import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { BinaRepository } from '@app/data-layer/repositories';
import { CUSTOM_MASK } from '@helpers/custom-validator';
import { ReplaySubject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'bina-catalog-item-title-edit-sidebar',
  templateUrl: './bina-catalog-item-title-edit-sidebar.component.html',
  styleUrls: ['./bina-catalog-item-title-edit-sidebar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BinaCatalogItemTitleEditSidbarComponent implements OnInit, OnDestroy, AfterViewInit {
  @Input() public favoriteHtsId: number;
  @Input() public favoriteHtsTitle: string = '';
  @Output() public save: EventEmitter<string> = new EventEmitter<string>();
  @Output() public close: EventEmitter<void> = new EventEmitter<void>();

  public titleControl: UntypedFormControl;
  public CUSTOM_MASK: typeof CUSTOM_MASK = CUSTOM_MASK;

  @ViewChild('titleControlInput')
  public titleControlInput: ElementRef;

  private destroy$: ReplaySubject<void> = new ReplaySubject<void>();

  constructor(private binaRepository: BinaRepository, private cdr: ChangeDetectorRef) {}

  public ngOnInit(): void {
    this.titleControl = new UntypedFormControl(this.favoriteHtsTitle);
  }

  public ngOnDestroy(): void {
    this.destroy$.next();
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.titleControlInput.nativeElement.focus();
    }, 100);
  }

  public saveInputPressKey(e: KeyboardEvent): void {
    const enterKey: string = 'Enter';
    if (e.code === enterKey) {
      this.onSave();
    }
  }

  public onSave(): void {
    const title = this.titleControl.value;
    this.binaRepository
      .updateFavoriteHtsNumber(this.favoriteHtsId, { title })
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: () => {
          this.cdr.markForCheck();
          this.save.emit(this.titleControl.value);
          this.close.emit();
        },
      });
  }
}
